import { render, staticRenderFns } from "./PublishCourseModal.vue?vue&type=template&id=f04ebd6e&"
import script from "./PublishCourseModal.vue?vue&type=script&lang=ts&"
export * from "./PublishCourseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports